import { render, staticRenderFns } from "./UpdateEstablishmentFollowUpSetting.vue?vue&type=template&id=0f79ca29&"
import script from "./UpdateEstablishmentFollowUpSetting.vue?vue&type=script&lang=js&"
export * from "./UpdateEstablishmentFollowUpSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports